module.exports = __webpack_public_path__ + "assets/sendinblue.ac159624.svg";